import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GLOBALSETTINGS } from '../data/constants';

interface ResourceCreatedSliceState {
  parentFolderId: number | null;
  trigger: number; 
}

const initialState: ResourceCreatedSliceState = {
  parentFolderId: GLOBALSETTINGS.DEFAULT_STATE,
  trigger: GLOBALSETTINGS.DEFAULT_STATE
};

const resourceCreatedSlice = createSlice({
  name: 'ResourceCreated',
  initialState,
  reducers: {
    setResourceCreated(state, action: PayloadAction<{ parentFolderId: number | null; }>) {
      state.parentFolderId = action.payload.parentFolderId;
      state.trigger += 1;
    },
    clearResourceCreated(state) {
      state.parentFolderId = GLOBALSETTINGS.DEFAULT_STATE;
      state.trigger = -1;
    },
  },
});

export const { setResourceCreated, clearResourceCreated } = resourceCreatedSlice.actions;

export default resourceCreatedSlice.reducer;
